import { createSlice } from '@reduxjs/toolkit'
import { fetchEntities } from './entityThunks';

function initializeCampaignState() {
  let initialState = {}
  return initialState;
}

export const entitySlice = createSlice({
  name: 'entity',
  initialState: initializeCampaignState(),
  reducers: {
    saveRequest: (state) => {
      state.save = true;
    },
    saveInit: (state) => {
      state.save = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEntities.pending, (state) => {
        state.loading = true;
        state.error = false;
      })
      .addCase(fetchEntities.fulfilled, (state, action) => {
        state.loading = false;
        state.error = false;
        state.entities = action.payload
      })
      .addCase(fetchEntities.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
  },
})

// Action creators are generated for each case reducer function
export const {
  saveRequest,
  saveInit,
} = entitySlice.actions

export default entitySlice.reducer